import { services } from '@billow/js-helpers'

let guard = (context) => new Promise((resolve, reject) => {
  return (services.auth.token()) ? resolve() : reject({
    name: 'login'
  })
})

export default { name: 'auth', run: guard }